"use strict";
function trimPercent(value) {
  return value.replace(/\.?0+$/, "");
}
export function formatPoolFeePips(feePips) {
  if (feePips === void 0 || !Number.isFinite(feePips)) {
    return "-";
  }
  const percent = feePips / 1e4;
  if (percent === 0) {
    return "0%";
  }
  const decimals = percent < 0.01 ? 4 : percent < 1 ? 3 : 2;
  return `${trimPercent(percent.toFixed(decimals))}%`;
}
export function getPoolFeeModeLabel(feeDetails) {
  if (feeDetails?.dynamicFee) {
    return "Dynamic";
  }
  if (feeDetails?.customFee) {
    return "Custom";
  }
  return void 0;
}
